import React from "react";
import { arrayFrom } from "../../../../../../utilities/general";
import { Skeleton } from "../../../../../../shared/Skeleton/Skeleton";
import styles from "./styles.module.scss";

export const Loading = () => (
  <div className={styles.root}>
    {arrayFrom(5).map((i) => (
      <Skeleton key={i} />
    ))}
  </div>
);
